module.exports = require("@common-stack/client-core");